import {
  NAV_ASSET_LIST_NAME,
  NAV_ASSET_PROJECT_LIST_NAME,
  NAV_ORGANIZATION_LIST_NAME,
  NAV_PROJECT_LIST_NAME,
} from '../redux/state';


/**
 *
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getState(rootState) {
  return rootState.appNavigation;
}

export function getNavAssets(rootState) {
  return getState(rootState)[NAV_ASSET_LIST_NAME];
}

export function getNavAssetProjects(rootState) {
  return getState(rootState)[NAV_ASSET_PROJECT_LIST_NAME];
}

export function getNavOrganizations(rootState) {
  return getState(rootState)[NAV_ORGANIZATION_LIST_NAME];
}

export function getNavProjects(rootState) {
  return getState(rootState)[NAV_PROJECT_LIST_NAME];
}



// WEBPACK FOOTER //
// ./src/js/app/navigation/reducers/state.js